import './Loading.css'

const Loading = () => {
	return (
		<div> Map is loading...</div>
	)
}
export default Loading;